import {useTranslation} from "react-i18next";
import {Link, useLocation, useNavigate, useSearchParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import store from "../../reducers/createReducers";
import {GLOBAL_CONSTANTS} from "../../constants/global-constants";
import SvgIcon from "../svg-icon";
import {show} from "@intercom/messenger-js-sdk";
import stringHelper from "../../helpers/string-helper";
import './styles/index.scss'
import './styles/button.css'

const LowBar = () => {
    const navigate = useNavigate()
    const {authenticated} = useSelector(state => state.authenticationReducer)

    const {sidebarShown, agent, headerSearchShow, chatShown, configuration} = useSelector(state => state.globalReducer)

    const {i18n, t} = useTranslation();
    const currentLanguage = i18n.language; // Get the current language

    const location = useLocation()
    const [active, setActive] = useState('')
    const [olderActive, setOlderActive] = useState('')
    const [searchParams, setSearchParams] = useSearchParams()

    const handleHome = () => navigate('/')
    // const handleCasino = () => navigate(stringHelper.getLocalizedPath(currentLanguage, `/casino`))
    // const handleCasino = () => navigate(stringHelper.getLocalizedPath(currentLanguage, `/casino`))
    const handleCasino = () => navigate(stringHelper.getLocalizedPath(currentLanguage, [ 24, 37]?.includes(configuration?.w_id) ? '/casino/group/lobby' : '/casino'))

    // stringHelper.getLocalizedPath(currentLanguage, configuration?.w_id === 24 ? '/casino/group/lobby' : '/casino/slots')
    const handleSportsbook = () => navigate('/sportsbook')
    const handleWallet = () => navigate('?modal=wallet')

    const handleProfile = () => navigate(stringHelper.getLocalizedPath(currentLanguage, `/settings`))
    const handleLiveCasino = () => navigate(stringHelper.getLocalizedPath(currentLanguage, `/casino/group/live-lobby`))

    const handleLiveSupport = () => {

        if (window?.Comm100API) {
            try {
                window?.Comm100API?.open_chat_window();
            } catch (e) {
                console.error(e)
            }
        } else {
            try {
                show()
            } catch (e) {
                console.error(e)
                alert(e.message)
            }
        }
    }

    useEffect(() => {
        if (sidebarShown) {
            setActive('menu')
        } else if (headerSearchShow) {
            setActive('search')
        } else if (chatShown) {
            setActive('chat')
        } else {
            setActive(olderActive)
        }
    }, [sidebarShown, headerSearchShow, chatShown])

    useEffect(() => {
        if (location?.pathname === '/casino') {
            setActive('casino')
            setOlderActive('casino')
        } else if (location?.pathname === '/sportsbook') {
            setActive('sportsbook')
            setOlderActive('sportsbook')
        } else if (location?.pathname?.includes('?modal=bets')) {
            setActive('bets')
        } else
            setActive(olderActive)

    }, [location?.pathname])

    useEffect(() => {
        var multisearch = document.querySelector('.main__search-drop');
        var headerSearchBtn = document.querySelector('.header__search-btn');
        var headerSearchBtnMob = document.querySelector('.header__search-btnmob');
        var lowbarSearchBtn = document.querySelector('.lowbar__btn--search');

        function toggleSearch() {
            multisearch?.classList?.toggle('main__search-drop--active');
        }

        headerSearchBtn?.addEventListener('click', toggleSearch);
        headerSearchBtnMob?.addEventListener('click', toggleSearch);
        lowbarSearchBtn?.addEventListener('click', toggleSearch);

        document?.addEventListener('click', function (event) {
            if (multisearch?.classList?.contains('main__search-drop--active')) {
                const isClickInside = multisearch?.contains(event.target);
                const isClickButton = headerSearchBtn?.contains(event.target) || headerSearchBtnMob?.contains(event.target) || lowbarSearchBtn?.contains(event.target);

                if (!isClickInside && !isClickButton) {
                    store.dispatch({
                        type: GLOBAL_CONSTANTS.SET_HEADER_SEARCH_SHOWN,
                        data: false
                    })
                    multisearch?.classList?.remove('main__search-drop--active');
                }
            }
        });
    }, [])

    useEffect(() => {
        const root = document.getElementById('root')


        if (agent?.isMobile) {
            console.log({
                sidebarShown
            })
            if (sidebarShown || chatShown || headerSearchShow) {
                document.body?.classList?.add('no-scroll')
                root?.classList?.add('no-scroll')
            } else {
                document.body?.classList?.remove('no-scroll')
                root?.classList?.remove('no-scroll')
            }
        } else {
            document.body?.classList?.remove('no-scroll')
            root?.classList?.remove('no-scroll')
        }
    }, [sidebarShown, headerSearchShow, chatShown, agent?.isMobile])

    const handleMenu = () => {
        handleDismissModal()
        handleShowMenu()
    }
    const handleShowMenu = () => {
        var multisearch = document.querySelector('.main__search-drop');

        multisearch?.classList?.toggle('main__search-drop--active');
    }

    const handleDismissModal = () => {
        handleCloseWizard()

        searchParams.delete('modal')
        setSearchParams(searchParams)
    }

    const handleChat = () => {
        handleCloseWizard()
        if (!authenticated)
            return navigate(stringHelper.getModalPath('register', searchParams))


        // const chat = document.getElementById('listeners');
        //
        // chat.classList.add('active');


    }

    const [isOpen, setIsOpen] = useState(false)

    const handleClick = () => {
        if (isOpen) {
            handleCloseWizard()
        } else {
            handleOpenWizard()
        }
    }
    useEffect(() => {
        console.clear();
        var isAnimating = false;
        var button = document.querySelector(".sticky-menu-container .outer-button");

        // button.addEventListener("animationstart", function (event) {
        //     // isAnimating = true;
        // });
        //
        // button.addEventListener("animationend", function (event) {
        //     // isAnimating = false;
        //     this.classList.remove("clicked");
        // });


    }, [])
    const handleCloseWizard = () => {
        var isAnimating = false;
        const button = document.querySelector(".sticky-menu-container .outer-button");
        const menu = document.querySelector(".sticky-menu-container .inner-menu");
        const closeIcon = document.querySelector(".sticky-menu-container .outer-button .close-icon");
        const arrowIcon = document.querySelector(".sticky-menu-container .outer-button .arrow-icon");
        const menuItems = document.querySelectorAll(".sticky-menu-container .inner-menu > .menu-list > .menu-item");

        const itemTexts = document.querySelectorAll(".sticky-menu-container .inner-menu > .menu-list > .menu-item > .item-text");
        const mainIcon = document.getElementById('main-icon')


        menu?.classList.add("closed");
        closeIcon?.classList.remove("show");
        closeIcon?.classList.add("hide");
        arrowIcon?.classList.remove("hide");
        arrowIcon?.classList.add("show");
        mainIcon?.classList.remove("active");
        menuItems.forEach(function (item) {
            console.log(item);
            item.classList.add("text-hides");
        });
        itemTexts.forEach(function (text, index) {
            setTimeout(function () {
                text.classList.remove("text-in");
            });
        });

        setIsOpen(false)
        const body = document.getElementById('body')
        body.style.opacity = 1
    }
    const handleOpenWizard = () => {
        var isAnimating = false;
        var button = document.querySelector(".sticky-menu-container .outer-button");
        var menu = document.querySelector(".sticky-menu-container .inner-menu");
        var closeIcon = document.querySelector(".sticky-menu-container .outer-button .close-icon");
        var arrowIcon = document.querySelector(".sticky-menu-container .outer-button .arrow-icon");
        var menuItems = document.querySelectorAll(".sticky-menu-container .inner-menu > .menu-list > .menu-item");

        var itemTexts = document.querySelectorAll(".sticky-menu-container .inner-menu > .menu-list > .menu-item > .item-text");
        const mainIcon = document.getElementById('main-icon')

        menu?.classList.remove("closed");
        closeIcon?.classList.remove("hide");
        closeIcon?.classList.add("show");
        arrowIcon?.classList.remove("show");
        mainIcon?.classList.add("active");
        arrowIcon?.classList.add("hide");


        menuItems.forEach(function (item) {
            console.log(item);
            item.classList.remove("text-hides");
        });
        itemTexts.forEach(function (text, index) {
            setTimeout(function () {
                text.classList.add("text-in");
            }, index * 150);
        });

        setIsOpen(true)
        const body = document.getElementById('body')
        body.style.opacity = 0.4
    }
    return (

        <div className="lowbar" id="tabbar">
            <nav>
                <ul>
                    <li className="left border-left">
                        <a
                            onClick={handleDismissModal}
                            className={`lowbar__btn lowbar__btn--menu ${active === 'casino' ? 'active' : ''}`}>
                            <SvgIcon id={'menu'}/>
                            <p>{t('lowbar.menu')}</p>
                        </a>

                        {/*<button*/}
                        {/*    onClick={handleDismissModal}*/}
                        {/*    className={`lowbar__btn lowbar__btn--menu ${active === 'menu' ? 'active' : ''}`}>*/}
                        {/*    <SvgIcon id={'menu'}/>*/}
                        {/*    <p>{t('lowbar.menu')}</p>*/}
                        {/*</button>*/}
                    </li>
                    {
                        authenticated ?
                            <li className="left">
                                <Link
                                    to={stringHelper.getLocalizedPath(currentLanguage, [24, 37]?.includes(configuration?.w_id) ? '/casino/group/lobby' : '/casino')}
                                    className={`lowbar__btn ${active === 'casino' ? 'active' : ''}`}>
                                    <SvgIcon id={'dice'}/>
                                    <p>{t('lowbar.casino')}</p>
                                </Link>
                            </li>

                            :

                            <li className="left">
                                <Link
                                    to={stringHelper.getLocalizedPath(currentLanguage, '/sportsbook')}
                                    className={`lowbar__btn ${active === 'sportsbook' ? 'active' : ''}`}>
                                    <SvgIcon id={'basketball'}/>
                                    <p>{t('lowbar.sports')}</p>
                                </Link>
                            </li>
                    }

                    {
                        authenticated &&
                        <li className="left">
                            <Link
                                to={stringHelper.getLocalizedPath(currentLanguage, '/sportsbook')}
                                className={`lowbar__btn ${active === 'sportsbook' ? 'active' : ''}`}>
                                <SvgIcon id={'basketball'}/>
                                <p>{t('lowbar.sports')}</p>
                            </Link>
                        </li>
                    }

                    <li className="center">

                        {
                            authenticated ?
                                <div className="sticky-menu-container">
                                    <div className="inner-menu closed">
                                        <ul className="menu-list">

                                            <li className="menu-item" onClick={e => {
                                                handleCloseWizard()

                                                handleCloseWizard()
                                                handleHome()
                                            }}>
                                                <div className="item-text">
                                                    <SvgIcon id={'homepage'}/>
                                                </div>
                                                <span className="item-text">
                                                    {t('sidebar.home')}
                                                </span>
                                            </li>

                                            <li className="menu-item" onClick={e => {
                                                handleCloseWizard()
                                                handleWallet()
                                            }}>
                                                <div className="item-text">
                                                    <SvgIcon id={'wallet'}/>

                                                </div>
                                                <span className="item-text">
                                            {t('sidebar.wallet')}
                                        </span>
                                            </li>

                                            <li className="menu-item" onClick={e => {
                                                handleCloseWizard()
                                                handleProfile()
                                            }}>


                                                <div className="item-text">
                                                    <SvgIcon id={'profile'}/>

                                                </div>
                                                <span className="item-text">
                                         {t('sidebar.profile')}
                                        </span>
                                            </li>


                                            {
                                                configuration?.chat_able &&

                                                <li className="menu-item lowbar__btn--chat" onClick={handleChat}>
                                                    <div className="item-text">
                                                        <SvgIcon id={'chat'}/>
                                                    </div>
                                                    <span className="item-text">
                                                    {t('lowbar.chat')}
                                                </span>
                                                </li>
                                            }

                                        </ul>
                                    </div>

                                    <div className="outer-button" onClick={handleClick}>
                                        <div className="icon-container icon plus" id={"main-icon"}>
                                            <SvgIcon id={'betss'}/>
                                        </div>
                                    </div>
                                </div>
                                :
                                <div className="sticky-menu-container">
                                    <div className="inner-menu closed">
                                        <button onClick={handleCasino}>
                                            <span>
                                                <div className="icon plus">
                                                    <SvgIcon id={'dice'}/>
                                                </div>
                                            </span>
                                        </button>
                                    </div>
                                </div>


                        }
                    </li>

                    {
                        authenticated &&
                        <li className="right">
                            <a type="button" className="lowbar__btn"
                               onClick={e => {
                                   handleCloseWizard()
                                   handleLiveCasino()
                               }}
                            >
                                <SvgIcon id={'live-casino'}/>
                                <p> {t('sidebar.live-casino')}</p>
                            </a>
                        </li>
                    }

                    <li className="right">

                        <a
                            onClick={handleDismissModal}
                            className={`lowbar__btn lowbar__btn--search ${active === 'search' ? 'active' : ''}`}>
                            <SvgIcon id={'search'}/>
                            <p>{t('lowbar.search')}</p>
                        </a>


                    </li>


                    <li className="right border-right">
                        <a onClick={handleLiveSupport} type="button" className="lowbar__btn">
                            <SvgIcon id={'headset'}/>
                            <p>{t('lowbar.support')}</p>
                        </a>
                    </li>
                </ul>
            </nav>


            {/*<svg>*/}
            {/*    <symbol id="home-icon" viewBox="0 0 59.465 59.465" xmlns="http://www.w3.org/2000/svg">*/}
            {/*        <path*/}
            {/*            d="M 56.985661,19.820762 31.645384,1.1013943 C 30.956423,0.65243677 30.492207,0.33684167 29.798775,0.33684167 c -0.692161,0 -1.176379,0.3155951 -1.845341,0.76455263 L 2.6131578,19.822668 C 2.2435816,20.188433 1.9946575,20.659611 1.8955959,21.17143 1.8181259,21.570216 1.7810551,21.975355 1.780024,22.367789 L 1.700022,52.816737 c -0.00914,3.478575 2.8308767,6.313274 6.3107339,6.313274 H 19.182679 c 1.750089,0 3.326304,0.147583 4.517583,-1.14403 1.084599,-1.172229 0.774474,-3.579199 0.78261,-5.170515 l 0.02373,-4.641278 c -0.08295,-2.40653 2.661452,-2.805693 5.055976,-2.805693 2.395789,0 4.790548,0.399163 4.873511,2.805693 l 0.160003,4.641278 c 0.0548,1.589123 -0.115711,4.170156 0.966344,5.342385 1.19128,1.291612 2.95377,0.97216 4.702589,0.97216 H 51.43695 c 3.479858,0 6.304122,-2.830889 6.313275,-6.314545 l 0.07999,-30.445772 c 0.0011,-0.396244 -0.116842,-1.194977 -0.116842,-1.194977 -0.102876,-0.5169 -0.356877,-0.988188 -0.727722,-1.353955 z"/>*/}
            {/*    </symbol>*/}

            {/*    <symbol id="plus-icon" viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg">*/}
            {/*        <path*/}
            {/*            d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z">*/}
            {/*        </path>*/}
            {/*    </symbol>*/}

            {/*    <symbol id="text-icon" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">*/}
            {/*        <path*/}
            {/*            d="M 128.2832 5 C 59.430423 5 4 60.430423 4 129.2832 L 4 385.7168 C 4 454.56958 59.430423 510 128.2832 510 L 384.7168 510 C 453.56958 510 509 454.56958 509 385.7168 L 509 129.2832 C 509 60.430423 453.56958 5 384.7168 5 L 128.2832 5 z M 161.97656 138.12891 L 351.02344 138.12891 C 360.9017 138.12891 368.85352 146.08073 368.85352 155.95898 L 368.85352 172.84961 C 368.85352 182.72785 360.90169 190.67969 351.02344 190.67969 L 282.77539 190.67969 L 282.77539 366.02734 C 282.77539 372.03531 277.93961 376.87109 271.93164 376.87109 L 241.06836 376.87109 C 235.0604 376.87109 230.22461 372.03531 230.22461 366.02734 L 230.22461 190.67969 L 161.97656 190.67969 C 152.0983 190.67969 144.14648 182.72785 144.14648 172.84961 L 144.14648 155.95898 C 144.14648 146.08073 152.0983 138.12891 161.97656 138.12891 z "/>*/}
            {/*    </symbol>*/}

            {/*    <symbol id="video-icon" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">*/}
            {/*        <path*/}
            {/*            d="M 128.2832 5 C 59.430423 5 4 60.430423 4 129.2832 L 4 385.7168 C 4 454.56958 59.430423 510 128.2832 510 L 384.7168 510 C 453.56958 510 509 454.56958 509 385.7168 L 509 129.2832 C 509 60.430423 453.56958 5 384.7168 5 L 128.2832 5 z M 210.88281 167.01562 L 350.11719 255.50195 L 210.88281 350.49414 L 210.88281 167.01562 z "/>*/}
            {/*    </symbol>*/}

            {/*    <symbol id="camera-icon" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">*/}
            {/*        <path*/}
            {/*            d="M 322.66949,257.5 A 66.169487,66.169487 0 0 1 256.5,323.66949 66.169487,66.169487 0 0 1 190.33051,257.5 66.169487,66.169487 0 0 1 256.5,191.33051 66.169487,66.169487 0 0 1 322.66949,257.5 Z M 128.2832,5 C 59.430423,5 4,60.430423 4,129.2832 V 385.7168 C 4,454.56958 59.430423,510 128.2832,510 H 384.7168 C 453.56958,510 509,454.56958 509,385.7168 V 129.2832 C 509,60.430423 453.56958,5 384.7168,5 Z M 256.5,137.09375 A 120.40678,120.40678 0 0 1 376.90625,257.5 120.40678,120.40678 0 0 1 256.5,377.90625 120.40678,120.40678 0 0 1 136.09375,257.5 120.40678,120.40678 0 0 1 256.5,137.09375 Z"/>*/}
            {/*    </symbol>*/}

            {/*    <symbol id="settings-icon" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">*/}
            {/*        <path d="M509.931,223.915c-3.349-25.835-30.251-43.52-56-33.877c-9.643,3.648-21.248-1.771-25.6-11.499*/}
            {/*		c-5.205-11.605-11.584-22.72-19.008-33.045c-6.613-9.195-5.355-21.227,2.859-28.011c9.813-8.064,15.296-19.989,15.04-32.683*/}
            {/*		c-0.256-12.907-6.336-24.789-16.683-32.64c-17.024-12.885-35.584-23.616-55.189-31.872c-5.291-2.219-10.837-3.349-16.491-3.349*/}
            {/*		c-20.437,0-37.675,14.528-41.003,34.539c-1.749,10.517-11.712,17.664-22.933,16.448c-12.459-1.323-25.429-1.323-37.867,0*/}
            {/*		c-11.179,1.216-21.184-5.931-22.933-16.448c-3.328-20.011-20.565-34.539-41.003-34.539c-5.653,0-11.2,1.131-16.469,3.349*/}
            {/*		c-19.627,8.256-38.187,18.965-55.211,31.872c-10.325,7.851-16.405,19.733-16.661,32.619c-0.256,12.715,5.227,24.619,15.04,32.725*/}
            {/*		c8.235,6.763,9.451,18.795,2.859,27.968c-7.424,10.325-13.824,21.44-19.029,33.045c-4.352,9.728-15.104,15.445-25.835,11.413*/}
            {/*		c-4.693-1.749-9.579-2.645-14.528-2.645c-20.821,0-38.528,15.744-41.237,36.629C0.704,234.496,0,245.312,0,256*/}
            {/*		c0,10.688,0.704,21.504,2.069,32.085c3.328,25.813,30.208,43.499,56,33.877c9.621-3.648,21.248,1.771,25.6,11.499*/}
            {/*		c5.205,11.605,11.584,22.72,19.008,33.045c6.613,9.195,5.355,21.227-2.859,28.011c-9.813,8.064-15.296,19.989-15.04,32.683*/}
            {/*		c0.256,12.907,6.336,24.789,16.683,32.64c17.024,12.885,35.584,23.616,55.189,31.872c5.291,2.219,10.837,3.349,16.491,3.349*/}
            {/*		c20.437,0,37.675-14.528,41.003-34.539c1.749-10.517,11.733-17.557,22.933-16.448c12.437,1.323,25.408,1.323,37.867,0*/}
            {/*		c11.221-1.131,21.184,5.931,22.933,16.448c3.328,20.011,20.565,34.517,41.003,34.539c5.653,0,11.2-1.131,16.469-3.349*/}
            {/*		c19.605-8.256,38.187-18.965,55.189-31.872c10.325-7.851,16.427-19.733,16.683-32.619c0.256-12.715-5.227-24.619-15.04-32.725*/}
            {/*		c-8.235-6.763-9.451-18.795-2.859-27.968c7.424-10.325,13.824-21.44,19.029-33.045c4.352-9.749,15.125-15.445,25.835-11.413*/}
            {/*		c4.693,1.771,9.579,2.667,14.528,2.667c20.821,0,38.528-15.744,41.237-36.629C511.296,277.397,512,266.624,512,256*/}
            {/*		C512,245.376,511.296,234.603,509.931,223.915z M256,341.333c-47.061,0-85.333-38.272-85.333-85.333s38.272-85.333,85.333-85.333*/}
            {/*		s85.333,38.272,85.333,85.333S303.061,341.333,256,341.333z"/>*/}
            {/*    </symbol>*/}
            {/*</svg>*/}


            {/*<div className="support">*/}
            {/*    <a href="https://twitter.com/DevLoop01" target="_blank"><i className="fab fa-twitter-square"></i></a>*/}
            {/*    <a href="https://dribbble.com/devloop01" target="_blank"><i className="fab fa-dribbble"></i></a>*/}
            {/*</div>*/}


        </div>

    )
}

export default LowBar
